import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse, Card, CardBody, CardTitle, Table } from 'reactstrap';
import _ from 'lodash';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { versionsPresenter } from '../../../Utils/presenters/vincheck/versionsPresenter';
import Translate from '../../common/Translate';
import { currencySign } from '../../../Utils/currencySign';

const VersionsBloc = (vincheck) => {
  const [versions] = useState(_.get(vincheck, `versions`, null));
  const [isBlocOpen, setIsBlocOpen] = useState(true);
  const toggleBloc = () => setIsBlocOpen(!isBlocOpen);

  useEffect(() => {
    versionsPresenter(versions);
  }, [versions]);

  return (
    <Card className="card-window mt-4 mr-3 ml-4">
      <CardTitle>
        {versions && versions.length} <Translate code="versions_possible_according_registration" />
        <FontAwesomeIcon
          className="text-corrected float-right"
          onClick={toggleBloc}
          icon={isBlocOpen ? faChevronUp : faChevronDown}
        />
      </CardTitle>
      <Collapse isOpen={isBlocOpen}>
        <CardBody>
          <Table striped>
            <thead>
              <tr>
                <th> </th>
                <th>Cote B2C</th>
                <th>Reprise</th>
                <th>Stock réseau</th>
                <th>Stock pro</th>
                <th>Stock part</th>
                <th>Stock total</th>
              </tr>
            </thead>
            <tbody>
              {versions &&
                versions.map((record) => (
                  <tr>
                    <th scope="row">{_.get(record, 'referenceName', '')}</th>
                    <td>{currencySign(_.get(record, 'valuation.b2c', ''))}</td>
                    <td>{currencySign(_.get(record, 'valuation.corrected', ''))}</td>
                    <td>{_.get(record, 'marketInformation.nbrAdsOfNetwork', '')}</td>
                    <td>{_.get(record, 'marketInformation.nbrAdsOfOtherPro', '')}</td>
                    <td>{_.get(record, 'marketInformation.nbrAdsOfParticular', '')}</td>
                    <td>{_.get(record, 'marketInformation.totalAds', '')}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default VersionsBloc;
